import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { AiImageBadge } from '../components/AiImageBadge';

const Restaurant: React.FC = () => {
  const [activeTab, setActiveTab] = useState<string>('menu');
  
  // Varianti per le animazioni
  const fadeIn = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { duration: 1 } }
  };

  const slideUp = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8 } }
  };

  const staggerContainer = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.3
    }
  }
};


  return (
    <div className="min-h-screen pt-24">
      {/* Hero Section */}
      <section className="relative h-[60vh]">
        <div className="absolute inset-0 bg-black bg-opacity-40 z-10"></div>
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: 'url("/tavoli_giardino.jpg")' }}
        ></div>
        <AiImageBadge position="bottom-right" />
        
        <div className="container mx-auto px-4 h-full flex items-center relative z-20">
          <div className="max-w-3xl">
            <motion.h1 
              className="font-playfair text-4xl md:text-5xl text-white mb-4"
              initial="hidden"
              animate="visible"
              variants={fadeIn}
            >
              Il Ristorante
            </motion.h1>
            <motion.p 
              className="font-montserrat text-lg md:text-xl text-white mb-8"
              initial="hidden"
              animate="visible"
              variants={slideUp}
            >
              Stiamo lavorando per offrirvi un'esperienza culinaria unica, dove i sapori autentici incontrano l'eleganza del posto 
            </motion.p>
          </div>
        </div>
      </section>

{/*<div className="min-h-screen bg-crema flex flex-col items-center justify-center px-4 py-16">*/}
  <div className=" bg-crema flex flex-col items-center justify-center px-4 py-16">

      <motion.div 
        className="container mx-auto max-w-4xl text-center"
        initial="hidden"
        animate="visible"
        variants={staggerContainer}
      ></motion.div>
     {/* Messaggio principale */}
             <motion.div variants={fadeIn} className="mb-12 text-center">
               <h2 className="text-3xl md:text-4xl font-playfair text-verde-oliva mb-6">
                 Stiamo preparando qualcosa di speciale
               </h2>
               <p className="text-xl text-marrone mb-8 max-w-2xl mx-auto">
                 Il nostro ristorante è in fase di allestimento. Presto potrete gustare i sapori autentici della nostra terra, 
                 preparati con ingredienti freschi coltivati direttamente nella nostra azienda agricola.
               </p>
               <div className="h-0.5 w-16 bg-oro mx-auto"></div>
               
             </motion.div>
             
             {/* Countdown o data di apertura 
             <motion.div variants={fadeIn} className="mb-12">
               <p className="text-2xl font-medium text-verde-scuro mb-2">Apertura prevista</p>
               <p className="text-4xl font-playfair text-oro">Autunno 2025</p>
             </motion.div>*/} 
             
             {/* Caratteristiche del futuro ristorante 
             <motion.div 
               variants={staggerContainer}
               className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12"
             >
               <motion.div variants={fadeIn} className="p-6 bg-white rounded-lg shadow-md">
                 <div className="w-12 h-12 bg-verde-oliva rounded-full flex items-center justify-center mx-auto mb-4">
                   <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4"></path>
                   </svg>
                 </div>
                 <h3 className="text-xl font-playfair text-verde-scuro mb-2">Cucina a km zero</h3>
                 <p className="text-marrone">Ingredienti freschi provenienti direttamente dalla nostra azienda agricola.</p>
               </motion.div>
               
               <motion.div variants={fadeIn} className="p-6 bg-white rounded-lg shadow-md">
                 <div className="w-12 h-12 bg-verde-oliva rounded-full flex items-center justify-center mx-auto mb-4">
                   <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 15.546c-.523 0-1.046.151-1.5.454a2.704 2.704 0 01-3 0 2.704 2.704 0 00-3 0 2.704 2.704 0 01-3 0 2.704 2.704 0 00-3 0 2.704 2.704 0 01-3 0 2.701 2.701 0 00-1.5-.454M9 6v2m3-2v2m3-2v2M9 3h.01M12 3h.01M15 3h.01M21 21v-7a2 2 0 00-2-2H5a2 2 0 00-2 2v7h18zm-3-9v-2a2 2 0 00-2-2H8a2 2 0 00-2 2v2h12z"></path>
                   </svg>
                 </div>
                 <h3 className="text-xl font-playfair text-verde-scuro mb-2">Ambiente elegante</h3>
                 <p className="text-marrone">Un'atmosfera raffinata e accogliente per momenti indimenticabili.</p>
               </motion.div>
               
               <motion.div variants={fadeIn} className="p-6 bg-white rounded-lg shadow-md">
                 <div className="w-12 h-12 bg-verde-oliva rounded-full flex items-center justify-center mx-auto mb-4">
                   <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7"></path>
                   </svg>
                 </div>
                 <h3 className="text-xl font-playfair text-verde-scuro mb-2">Menu stagionale</h3>
                 <p className="text-marrone">Piatti che seguono il ritmo delle stagioni, sempre freschi e genuini.</p>
               </motion.div>
             </motion.div>*/}
             
             {/* Form per notifiche 
             <motion.div variants={fadeIn} className="max-w-md mx-auto">
               <h3 className="text-2xl font-playfair text-verde-scuro mb-4">Resta aggiornato</h3>
               <p className="text-marrone mb-6">Lascia la tua email per ricevere aggiornamenti sull'apertura e offerte speciali.</p>
               
               <form className="space-y-4">
                 <div className="flex">
                   <input 
                     type="email" 
                     placeholder="La tua email" 
                     className="flex-grow px-4 py-3 border border-gray-300 rounded-l-md focus:outline-none focus:ring-2 focus:ring-verde-oliva"
                     required
                   />
                   <button 
                     type="submit" 
                     className="bg-verde-oliva hover:bg-verde-scuro text-white font-medium py-3 px-6 rounded-r-md transition duration-300 ease-in-out"
                   >
                     Iscriviti
                   </button>
                 </div>
               </form>
             </motion.div>*/}
             
             {/* Social media */}
             <motion.div variants={fadeIn} className="mt-12">
               <p className="text-marrone mb-4">Seguici sui social per rimanere aggiornato</p>
               <div className="flex justify-center space-x-4">
                 <a href="https://www.facebook.com/villadarcobaronissi/" target='_blank' rel="noopener noreferrer" className="text-verde-oliva hover:text-verde-scuro transition-colors">
                   <span className="sr-only">Facebook</span>
                   <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                     <path fillRule="evenodd" d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" clipRule="evenodd" />
                   </svg>
                 </a>
                 <a href="https://www.instagram.com/villadarco_baronissi/" target='_blank' rel="noopener noreferrer" className="text-verde-oliva hover:text-verde-scuro transition-colors">
                   <span className="sr-only">Instagram</span>
                   <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                     <path fillRule="evenodd" d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z" clipRule="evenodd" />
                   </svg>
                 </a>
               </div>
             </motion.div>
          

      
        </div>
    </div>
  );
};

export default Restaurant;
